import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useUser } from '../../../contexts/UserContext';
import FilterPopup from '../../FilterPopup';
import { getUniqueValues, uniqueFilterValues, useNavigateToDirectory, handleFilterChange, uniqueFilterValuesMultipleKeys } from '../../../utils/helperFunctions';
import { ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import MultiComboBoxInput from '../MultiComboBoxInput';
import CompetitionFilterPopup from './CompetitionFilterPopup';

export default function CompetitionFilters({ users }) {
  const { 
    events,
    directory,
    schoolCompetitionData, 
    competitionFilters: filters, 
    setCompetitionFilters: setFilters, 
    competitionSearchTerm: searchTerm,
    setCompetitionSearchTerm: setSearchTerm,
    clearEventFilters
  } = useUser();

  const dropdownRefs = useRef([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const teamSlice = useMemo(() => {
    if (!schoolCompetitionData || !schoolCompetitionData.teamMap) return [];

    return Object.values(schoolCompetitionData.teamMap).map(team => {
      return {
        ...team,
        teamMembers: Object.values(team.teamMembers).map(member => {
          if (member.hasJoined) {
            const directoryUser = directory.find(user => user.id === member.id);
            return { ...member, ...directoryUser };
          }
          return member;
        })
      };
    });
  }, [schoolCompetitionData, directory]);

  const freelancerSlice = useMemo(() => {
    if (!schoolCompetitionData || !schoolCompetitionData.freelancerMap) return [];

    return Object.values(schoolCompetitionData.freelancerMap).map(freelancer => {
      if (freelancer.hasJoined) {
        const directoryUser = directory.find(user => user.id === freelancer.directoryId);
        return { ...freelancer, ...directoryUser };
      }
      return freelancer;
    });
  }, [schoolCompetitionData, directory]);

  const handleFilterOpen = () => setFilterOpen(!filterOpen);

  const combinedSlice = useMemo(() => {
    return [...teamSlice, ...freelancerSlice];
  }, [teamSlice, freelancerSlice]);

const uniqueSkillTypes = uniqueFilterValuesMultipleKeys(combinedSlice, 'teamNeeds', 'freelancerSkills')
const uniqueTeamTypes = uniqueFilterValuesMultipleKeys(combinedSlice, 'interestSectors', 'competitionSectors')
// });
  return (
    // <div className="directory__filter-container">
    <>
         {/* <label htmlFor="search-field" className="tw-sr-only">
                  Search
                </label> */}
                {/* <MagnifyingGlassIcon
                  className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-h-full tw-w-5 tw-text-gray-400"
                  aria-hidden="true"
                /> */}
              {/* <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4 tw-w-full tw-pt-4"> */}
                <div className="tw-grid tw-grid-cols-4 tw-gap-4 tw-w-full">
                  <input
                    id="search-field"
                    className="tw-block tw-w-full tw-h-full tw-border tw-border-gray-300 tw-rounded-md  md:tw-pt-0 tw-pb-0 
                    tw-pl-0 tw-pr-0 tw-text-gray-900 tw-placeholder:text-gray-400 
                    sm:tw-text-sm dark:tw-text-white dark:tw-bg-black tw-col-span-3"
                    // placeholder="Search by name, section i.e. '- C', and more" 
                    placeholder="Search by name, school, background, and description" 
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}  
                    type="search"
                    name="search"
                  />
                  <div className="tw-col-span-1 tw-flex tw-justify-center tw-items-center">
                    <button
                      type="button"
                      className="tw-rounded-full tw-bg-indigo-600 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-indigo-500 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-indigo-600"
                      onClick={handleFilterOpen}
                    >
                      Filters
                    </button>
                  </div>
                </div>

                

                {/* tw-focus:ring-0 */}
                <CompetitionFilterPopup
                   open={filterOpen}
                   filters={filters}
                   skillItems={uniqueSkillTypes}
                   skillSingleSelect={false}
                   teamTypeItems={uniqueTeamTypes}
                   teamTypeSingleSelect={false}
                   setOpen={setFilterOpen}
                   setFilters={setFilters}
                   handleFilterChange={handleFilterChange}
                   clearEventFilters={clearEventFilters}
                  />       
      </>
  );
}
